import {Component, Input, OnInit, ChangeDetectionStrategy, HostBinding} from '@angular/core';
import {EntityAction} from 'app/blocks/model/action.model';
import {LogService} from 'app/blocks/service/log.service';
import {debounce} from 'lodash';

@Component({
    selector: 'di-entity-action-menu',
    templateUrl: './di-entity-action-menu.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class DiEntityActionMenuComponent implements OnInit {
    @Input() entity: any;
    @Input() actions: EntityAction[];
    @Input() resource: any;

    constructor(private _logService: LogService) {}

    ngOnInit(): void {}

    private debouncedLog = debounce((action) => {
        this._logService.log(action, {});
    }, 500);

    performAction(act: EntityAction): void {
        this.debouncedLog(`${act.label} ${this.resource.name} (Action menu)`);
        act.action(this.entity);
    }
}
